<template>
<div id="ProfileRecommendations" class="row">
    <div class="chart-segment-options col-3">
        <modal-link modal-id="Profile Recommendations" :content-list="pageContent"></modal-link>
        <a href="#!" v-show="!displayProfileRecommendations" @click="handleToggle">Show Recommendations<i class="fa fa-chevron-down ml-1"></i></a>
        <a href="#!" v-show="displayProfileRecommendations" @click="handleToggle">Hide Recommendations<i class="fa fa-chevron-up ml-1"></i></a>
    </div>
    <div v-if="displayProfileRecommendations && !isVerbatimLocked" class="product-recommendations-section col-9">
        <div>
            <div class="product-recommendations-intro">
                Generating Roadmap Recommendations uses data from your current Profile and Sentiment Themes above. Select which parts below to include for generating recommendations.
            </div>
            <div class="chart-criteria-section-1-product-recommendations-section">
                <div class="chart-criteria-row">
                    <div class="form-group">
                        <input id="includeValueGaps" name="includeValueGaps" type="checkbox" true-value="Y" false-value="N" v-model="includeValueGaps" />
                        <span class="ml-1 mr-3 mb-0">Include Value Gaps</span>
                    </div>
                    <div class="form-group">
                        <input id="includeExpectations" name="includeExpectations" type="checkbox" true-value="Y" false-value="N" v-model="includeExpectations" />
                        <span class="ml-1 mr-3 mb-0">Include Expectations</span>
                    </div>
                    <div class="form-group">
                        <input id="includePerformance" name="includePerformance" type="checkbox" true-value="Y" false-value="N" v-model="includePerformance" />
                        <span class="ml-1 mr-3 mb-0">Include Performance</span>
                    </div>
                    <div class="form-group">
                        <input id="includeWillingnessToPay" name="includeWillingnessToPay" :disabled="!enableWillingnessToPay" type="checkbox" true-value="Y" false-value="N" v-model="includeWillingnessToPay" />
                        <span class="ml-1 mb-0">Include Willingness %s</span>
                    </div>
                </div>
                <div class="chart-criteria-row">
                    <div class="form-group">
                        <input id="includeRelativeStrength" name="includeRelativeStrength" :disabled="!enableIncludeRelativeStrength" type="checkbox" true-value="Y" false-value="N" v-model="includeRelativeStrength" />
                        <span class="ml-1 mr-3 mb-0">Include Relative Strength</span>
                    </div>
                    <div class="form-group">
                        <input id="includeSentimentThemes" name="includeSentimentThemes" :disabled="!sentimentsData || Object.keys(sentimentsData).length === 0" type="checkbox" true-value="Y" false-value="N" v-model="includeSentimentThemes" />
                        <span class="ml-1 mr-3 mb-0">Include Sentiment Themes</span>
                    </div>
                    <div class="form-group" v-show="false">
                        <input id="includeReport" name="includeReport" type="checkbox" true-value="Y" false-value="N" v-model="includeReport" />
                        <span class="ml-1 mb-0">Include "The W Report" as PPTX file</span>
                    </div>
                </div>
                <div class="chart-criteria-row">
                    <div class="col-7 pl-0 pt-1 pb-2 d-flex align-items-center">
                        <div class="col-3 pl-0 pr-0">
                            <label class="sub-heading-label"># of Recommendations</label>
                        </div>
                        <div class="col-3 pl-0">
                            <select
                            id="number_of_recommendations"
                            name="number_of_recommendations"
                            class="custom-select shadow w-100"
                            v-model="number_of_recommendations"
                            >
                                <option value="5">Select</option>
                                <option v-for="(option, idxNumberOfRecommendationOptions) in number_of_recommendation_options" v-bind:value="option" v-bind:key="idxNumberOfRecommendationOptions">
                                    {{ option }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>  
            </div>
            <button class="btn btn-primary generate-recommendations-btn" @click="generateProfileRecommendations" :disabled="(this.$root.getLoading() && !processingComplete) || deactivateGeneratedThemesButton || oneTimeRunOnlyForInsiderUser">
                <span>Generate Recommendations</span>
                <span v-show="this.$root.getLoading() && !processingComplete" class="spinner-border spinner-border-sm"></span>
            </button>
            <div v-show="oneTimeRunOnlyForInsiderUser" class="form-row pt-1">
                <div v-show="oneTimeRunOnlyForInsiderUser" class="text-danger ml-2">Additional Recommendation Analysis is not active for your account. Contact your W Ratings Advisor or <a href="mailto:insider@wratings.com">insider@wratings.com</a> for more information.</div>
            </div>
            <div v-show="deactivateGeneratedThemesButton" class="form-row pt-1">
                <div v-show="deactivateGeneratedThemesButton" class="text-danger ml-2">Recommendation Analysis is not active for your account. Contact your W Ratings Advisor or <a href="mailto:insider@wratings.com">insider@wratings.com</a> for more information.</div>
            </div>
        </div> 
    </div>
    <!-- Response area -->
    <div class="row justify-content-center pt-4" v-if="showResults && displayProfileRecommendations">
        <div v-if="!isExplorerPage" class="col-10">
            <span style='color:#7F7F7F; font-family: "Franklin Gothic Medium Cond";'>
                AI-generated actions are for advisory purposes and should be used as a starting point for your roadmap.
            </span>
        </div>
        <div id="product-recommendations-data-container"  class="col-10">
            <div class="chart-header-container d-flex">
                <div class="d-flex title" style="padding-left: 0 !important;">
                <h4 class="text-primary mt-1 mb-0">
                    Roadmap Recommendations
                </h4>
                </div>          
            </div>
            <table id="recommendations-detailed-data" class="recommendations-table" cellspacing="0" style="padding-left: 0 !important;">
                <thead class="align-middle">
                    <tr>
                        <th class="align-middle text-center" style="padding-right: 0px !important">#</th>
                        <th class="align-middle">Recommendation</th>
                        <th class="align-middle">The Data</th>
                        <th class="align-middle">The Action</th>
                        <th class="align-middle">The "Why" behind the Recommendation</th>
                    </tr>                    
                </thead>
                <tbody></tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import $ from "jquery";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ViewMixins from "../../mixins/ViewMixins.vue";
import SurveyService from "../../services/survey.service";
import UserService from "../../services/user.service";
import AdminService from "../../services/admin.service";
import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import GoogleService from "../../services/google.service";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import ClientSettingsService from "../../services/client.settings.service";
import AIService from "../../services/ai.service";
import TableService from "../../services/table.service";

export default {
    name: "ProfileRecommendations",
    mixins: [ContentMixins, ViewMixins, DataTableMixins, AdminMixins, ChartCriteriaMixins, GoogleService],
    components: {
        // ChartDisplaySkeleton
    },
    data() {
        return {
            displayProfileRecommendations: false,
            clientSettings: {}, 
            includeValueGaps: "Y",
            includeExpectations: "Y",
            includePerformance: "Y",
            includeWillingnessToPay: "Y",
            includeRelativeStrength: "Y",
            includeSentimentThemes: "Y",
            includeReport: "N",
            processingComplete: true,
            processInitiated: false,
            showResults: false,
            topRecommendations: [],
            autoProcessRecommendationsByAI: false,
            number_of_recommendation_options: [1,2,3,4,5,10,15],
            number_of_recommendations: 5,
            isSavedCard: false,
            deactivateGeneratedThemesButton: false,
            oneTimeRunOnlyForInsiderUser: false,
            table: {
                id: "recommendations-detailed-data",
                class: "table display wrap row-border table-hover",
                configuration: {
                    dom: '<"w-100"<"d-flex"><B>>frtip',      
                    searching: false,
                    paging: false,
                    pageLength: 25,
                    select: true,
                    processing: false,
                    responsive: false,
                    destroy: true,
                    info: false,
                    order: [],
                    ordering: false,
                    keys: true,
                    sort: false,
                    bSortable: false,
                    bSort: false,
                    buttons: [],
                },
            },            
        };
    },
    props: {
        enableSentimentThemes: {
            type: Boolean,
            default: true
        },
        enableWillingnessToPay: {
            type: Boolean,
            default: true
        },
        enableIncludeRelativeStrength: {
            type: Boolean,
            default: true
        },
        entrySurveyCode: {
            type: String,
            default: SurveyService.getSurveyCode()
        },
        autoGenerateRecommendations: {
            type: Boolean,
            default: false
        },
        clientChart: {
            type: Object,
            default: function() {
                return {};
            }
        },
        clientObject: {
            type: Object,
            default: function() {
                return {};
            }
        },
        recommendationsData: {
            type: Object,
            default: () => null
        },
        sentimentsData: {
            type: Object,
            default: () => null
        },
        criteriaResultsCompanyList: {
            type: Array,
            default: function() {
                return [];
            }
        },
    },
    computed: {
        isVerbatimLocked() {
            return this.clientSettings.aiTypeId == 0;
        },
        noInputSelected() {
            if (this.includeValueGaps == "N" && this.includeExpectations == "N" 
                && this.includePerformance == "N" && this.includeWillingnessToPay == "N"
                && this.includeRelativeStrength == "N" && this.includeSentimentThemes == "N" ) {
                    return true;
                }
            return false;
        },
        noOfRespondents: function() {
            let returnNumber = 0;
            let resultClientList = this.criteriaResultsCompanyList.find(x => x.type === "client");
            if (typeof resultClientList !== "undefined") {
                if (resultClientList.list.length > 0) {
                    returnNumber = resultClientList.list[0].numberOfResults;
                }        
            }
            return returnNumber;
        },
    },
    mounted() {
        ClientSettingsService.getClientSettings(this.clientCode, this.setClientSettings, this);
    //    console.log('AI Recommendations chartData = ', this.aiRecommendations);
    },
    created() {},
    methods: {
        initResultTables(all = []) {
            const posSel = "#recommendations-detailed-data";
            
            // destroy if exists
            this.destroyDt(posSel);

            this.table.columns = TableService.getTopRecommendationResultsTableAttributes();
            const baseCfg = $.extend(true, {}, this.table.configuration);
            const cols = this.table.columns;

            // Positive table configuration
            const cfgPos = $.extend(true, {}, baseCfg, {
                data: all,
                columns: cols,
                columnDefs: [
                    {
                        targets: 0,          // first column
                        createdCell: function (td) {
                            $(td).css('text-align', 'center');
                        }
                    }
                ]
            });
            // buttons: use different container ids if you want separate toolbar per table
            $.extend(cfgPos, TableService.getTableButtons(this, "product-recommendations-data-container", undefined, undefined, false, "Recommendations"));

            this.$nextTick(() => {
                this.dtPositive = $(posSel).DataTable(cfgPos);
                this.dtPositive.columns.adjust().draw();
            });
            this.isSavedComments = false;
        },

        destroyDt(selector) {
            if ($.fn.dataTable.isDataTable(selector)) {
                $(selector).DataTable().destroy();
            }
        },
        setEnableIncludeRelativeStrength: function() {
            if (this.enableIncludeRelativeStrength) {
                this.includeRelativeStrength = "Y";
            } else {
                this.includeRelativeStrength = "N";
            }
        },
        setEnableSentimentThemes:function() {
            if (this.enableSentimentThemes) {
                this.includeSentimentThemes = "Y";
            } else {
                this.includeSentimentThemes = "N";
            }
        },
        setEnableWillingnessToPay: function() {
            if (this.enableWillingnessToPay) {
                this.includeWillingnessToPay = "Y";
            } else {
                this.includeWillingnessToPay = "N";
            }
        },
        loadDefaultCriteria() {
            this.setEnableIncludeRelativeStrength();
            this.setEnableSentimentThemes();
            this.setEnableWillingnessToPay();            
        },
        setClientSettings(response){
            this.clientSettings = ClientSettingsService.parseClientSettings(response.data.data);
            this.displayProfileRecommendations = (this.isVerbatimLocked || !this.processInitiated) ? false : true;
        },
        handleToggle() {
            if (this.isVerbatimLocked) {
                AdminService.displayErrorMessage({
                    text: "Profile Recommendations is not active for your organization. Contact your W Ratings Advisor for more information."
                });
                return;
            }
            this.toggleProfileRecommendations();
        },
        getDownloadFilename() {
            return "Recommendations - " + SurveyService.getSurveyName();
        },
        toggleProfileRecommendations() {
            let label = this.displayProfileRecommendations ? "close" : "open";
            GoogleService.logClickEvent("Profile Recommendations Section Toggle", label, 0, this);

            this.displayProfileRecommendations = !this.displayProfileRecommendations;
        },
        generateProfileRecommendations: function(){
            this.processingComplete = false;
            this.processInitiated = true;
            this.$root.setLoading(true);
            
            this.$nextTick(() => {
                this.$root.processServerRequest("Generating Recommendations");
                let params = new URLSearchParams();
                params.append("client_id", this.clientObject.clientId);
                params.append("survey_id", SurveyService.getSurveyId());
                params.append("user_id", UserService.getUserId());
                params.append("include_value_gaps", this.includeValueGaps);
                params.append("include_expectations", this.includeExpectations);
                params.append("include_performance", this.includePerformance);
                params.append("include_willingness_to_pay", this.includeWillingnessToPay);
                params.append("include_relative_strength", this.includeRelativeStrength);
                params.append("include_report", this.includeReport);
                params.append("include_sentiment_themes", this.includeSentimentThemes);
                params.append("number_of_recommendations", this.number_of_recommendations);
                
                params.append("chart_data", JSON.stringify(this.buildRecommendationsData()));
                if(this.includeSentimentThemes == 'Y') {
                    params.append("sentiment_themes", JSON.stringify(this.sentimentsData.themes));
                    params.append("download_commments_period", this.sentimentsData.startPeriod);
                    params.append("download_commments_end_period", this.sentimentsData.endPeriod);
                    params.append("number_of_themes", this.sentimentsData.numberOfThemes);
                    params.append("include_partial_responses", this.sentimentsData.includePartialResponses);
                }
                params.append("number_of_respondents", this.noOfRespondents);
                AIService.processRecommendations(params, this.processRecommendationsCallbacks);
            });
        },
        buildRecommendationsData() {
            const data = this.recommendationsData;
            
            const selectedCols = this.getSelectedColumnsForRecommendations(data);
            const colIndexes = this.getColumnIndexes(data, selectedCols);
            const filteredRows = this.getFilteredRows(data, colIndexes);

            return {
                cols: selectedCols, //headers
                rows: filteredRows,
                isPositiveCorrelation: data.isPositiveCorrelation
            };
        },
        getSelectedColumnsForRecommendations(data) {
            if (!data?.cols) return;
            const selectedCols = [];
            data.cols.forEach(col => {

                if (col.id === "need") {
                    selectedCols.push({ ...col });
                }
                if (this.includeValueGaps && col.id === "gap") {
                    selectedCols.push({ ...col });
                }
                if (this.includeExpectations && col.id === "customer-expectations") {
                    selectedCols.push({ ...col });
                }
                if (this.includePerformance && col.id === "performance") {
                    selectedCols.push({ ...col });
                }
                if (this.includeWillingnessToPay && col.id === "pricing-power") {
                    selectedCols.push({
                        ...col,
                        label: "Willing to expand"
                    });
                }
                if (this.includeRelativeStrength && col.id === "relative-strength") {
                    selectedCols.push({ ...col });
                }
            });
            return selectedCols;
        },
        getColumnIndexes(data, selectedCols) {
            return selectedCols.map(sc =>
                data.cols.findIndex(c => c.id === sc.id)
            );
        },
        getFilteredRows(data, colIndexes) {
            const needLookup = {};
            (data.emotionalNeedNamesMap || []).forEach(n => {
                needLookup[n.needName] = n.dimensionName;
            });

            return data.rows.map(row => {
                return colIndexes.map(i => {
                    const cell = row.c[i];
                    let value = cell ? cell.v : '';
                    const colId = data.cols[i].id;
                    if (colId === "pricing-power" && value !== '') {
                        value = value + "%";
                    } else if (colId === "need" && value !== '') {
                        value = needLookup[value] || value; // replace if mapping exists
                    } else {
                        let numVal = parseFloat(value);
                        if (typeof numVal === 'number' && !isNaN(numVal)) {
                            value = numVal.toFixed(2); 
                        }
                    }
                    return value;
                });
            });
        },
        loadCriteriaData() {
            this.$root.setLoading(true);
            this.processingComplete = false;
            
            let params = new URLSearchParams(this.clientChart.criteria);
            let autoProcessRecommendationsByAI = params.get("auto_process_recommendations_by_ai") || false;
            if (autoProcessRecommendationsByAI == "true" || autoProcessRecommendationsByAI == true) {
                this.autoProcessRecommendationsByAI = true;
                this.includeValueGaps = params.get("include_value_gaps") || "Y";
                this.includeExpectations = params.get("include_expectations") || "Y";
                this.includePerformance = params.get("include_performance") || "Y";
                this.includeWillingnessToPay = params.get("include_willingness_to_pay") || "Y";
                this.includeRelativeStrength = params.get("include_relative_strength") || "Y";
                this.includeSentimentThemes = params.get("include_sentiment_themes") || "Y";
                this.includeReport = params.get("include_report") || "N";
                this.number_of_recommendations = params.get("no_of_recommendations") || 5;
                this.showResults = true;
                this.displayProfileRecommendations = true;
                
                if (Object.keys(this.recommendationsData).length !== 0) {
                    this.generateProfileRecommendations();
                }
            }
            
        },
        saveToCard: function() {
            let params = new URLSearchParams();
            params.append("include_value_gaps", this.includeValueGaps);
            params.append("include_expectations", this.includeExpectations);
            params.append("include_performance", this.includePerformance);
            params.append("include_willingness_to_pay", this.includeWillingnessToPay);
            params.append("include_relative_strength", this.includeRelativeStrength);
            params.append("include_sentiment_themes", this.includeSentimentThemes);
            params.append("include_report", this.includeReport);
            params.append("no_of_recommendations", this.number_of_recommendations);
            params.append("auto_process_recommendations_by_ai", true);

            // params.append("chart_data", JSON.stringify(this.buildRecommendationsData()));
            // if(this.includeSentimentThemes == 'Y') {
            //     params.append("sentiment_themes", JSON.stringify(this.sentimentsData));
            // }

            this.$emit("save-profile-recommendations-criteria", params);
        },
        processRecommendationsCallbacks(response) {
            this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
            this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;

            this.$root.processServerResponse();
            let statusCode = response.status;
            this.showResults = true;
            this.displayProfileRecommendations = true;
            if (statusCode == 200) {
                this.saveToCard();
                
                const data = response.data.data || {};
                this.topRecommendations = data.topRecommendations || [];
                this.initResultTables(this.topRecommendations );
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
                this.initResultTables([]);
            }
            this.$root.setLoading(false);
            this.processingComplete = true;
            this.autoProcessRecommendationsByAI = false;
        },
        resetValues() {
            this.showResults = false;
            this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
            this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;
        }, 
    },
    watch: {
        // enableSentimentThemes: function(newVal) {
        //     this.setEnableSentimentThemes();
        // },
        // enableIncludeRelativeStrength: function(newVal) {
        //     this.setEnableIncludeRelativeStrength();
        // },
        enableWillingnessToPay: function(newVal) {
            if (!this.autoGenerateRecommendations){
                this.setEnableWillingnessToPay();
            }
        },
        clientChart: function() {
            if (this.clientChart != null && this.clientChart.clientChartId > 0 && this.autoGenerateRecommendations) {
                let params = new URLSearchParams(this.clientChart.criteria);
                this.isSavedCard = params.get("auto_process_recommendations_by_ai") || false;                
                if (this.isSavedCard) {
                     this.loadCriteriaData();
                } else {
                    this.processingComplete = false;    
                }
            } else {
                this.loadDefaultCriteria();
                this.isSavedCard = false;
                this.processingComplete = false;
            }
            this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
            this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;
        },
        entrySurveyCode: function(newVal, oldVal) {
            this.resetValues();
        },
        recommendationsData(newVal) {
            if (newVal && this.autoProcessRecommendationsByAI) {
                this.generateProfileRecommendations();
            }
        }
    },
};
</script>
